import AddIcon from '@mui/icons-material/Add'
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material'
import React, { useCallback } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  useCreateAdditionalPhoneMutation,
  useGetAdditionalPhonesForCustomerQuery,
  useUpdateCustomerDetailMutation
} from '../../../redux/api'
import { CustomerEntry } from '../../../sdk'
import { AdditionalPhonesTableEntry } from './AdditionalPhonesTableEntry'

interface Props {
  customerEntry: CustomerEntry
}

export const AdditionalPhonesTable: React.FC<Props> = ({ customerEntry }) => {
  const { accessToken } = useAccessTokenAndShopId()
  const { data: additionalPhones } = useGetAdditionalPhonesForCustomerQuery({
    authorization: accessToken,
    customer: customerEntry.id!
  })

  const [updateCustomer] = useUpdateCustomerDetailMutation()

  const customerId = customerEntry.id!
  const customerInformation = customerEntry.information

  const markAsPrimary = useCallback(
    async (phone: string) => {
      await updateCustomer({
        customerEntry: {
          id: customerId!,
          information: {
            ...customerInformation,
            phone
          }
        },
        authorization: accessToken
      })
    },
    [updateCustomer, customerId, customerInformation, accessToken]
  )

  const [createAdditionalPhone] = useCreateAdditionalPhoneMutation()

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Phone Numbers</TableCell>
            <TableCell />
            <TableCell align="right">
              <Tooltip title="Add Phone Number">
                <IconButton
                  onClick={() =>
                    createAdditionalPhone({
                      authorization: accessToken,
                      customerAdditionalPhoneInfo: {
                        customer: customerId,
                        phone: '+12223334444',
                        description: 'Additional Phone'
                      }
                    })
                  }>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Primary Phone</TableCell>
            <TableCell align="right">
              {customerEntry.information?.phone
                ? customerEntry.information?.phone
                : 'No primary phone set'}
            </TableCell>
            <TableCell />
          </TableRow>
          {additionalPhones?.map((phone) => (
            <AdditionalPhonesTableEntry
              key={phone.id}
              phone={phone}
              markAsPrimary={markAsPrimary}
              isPrimary={customerInformation?.phone === phone.info?.phone}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
